const translation = {
  pageTitle: 'OmaPro Portaali',
  menu: {
    home: 'Etusivu',
    services: 'Palvelut',
    omaAnnosServices: 'Oma-annospalvelut',
    omaAnnosService: 'Oma-annospalvelu',
    omaAnnosOrders: 'Tilaukset',
    omaAnnosOrderHistory: 'Tilaushistoria',
    omaAnnosOrderSchedules: 'Tilausaikataulut / Poikkeukset',
    omaAnnosProducts: 'Valmistevalikoima',
    omaAnnosPhysicalProducts: 'Annosjakelumateriaalin tilaus',
    omaAnnosOrderTickets: 'Korjauspyynnöt',
    omaAnnosProductShortages: 'Tuotepuutokset',
    omaAnnosCustomership: 'Oma asiakkuus',
    omaAnnosCustomerGroupManagement: 'Asiakasryhmien hallinta',
    omaProServices: 'OmaPro-palvelut',
    omaProMobile: 'OmaPro Mobiili',
    medicineIdentification: 'Lääkkeentunnistus',
    support: 'Tuki',
    newsletters: 'Ajankohtaiset',
    faq: 'Usein kysytyt kysymykset',
    contact: 'Ota yhteyttä',
    materials: 'Materiaalit',
    shop: 'Kauppa',
  },
  userMenu: {
    ownCustomership: 'Oma asiakkuus',
    changeCustomership: 'Vaihda asiakasta',
    selectLanguage: 'Valitse kieli',
    logout: 'Kirjaudu ulos',
    infoAndUsers: 'Yrityksen tiedot ja käyttäjät',
    deliveryDetails: 'Toimituserittelyt',
  },
  newsletters: {
    title: 'Ajankohtaiset',
    allNewsletters: 'Kaikki ajankohtaiset',
  },
  faq: {
    title: 'Usein kysytyt kysymykset',
  },
  user: {
    title: 'Omat tiedot',
    userRoles: 'Käyttäjäroolit',
    marketingAuthorization: 'Markkinointilupa',
    marketingAuthorizationInfo:
      'Tämän suostumuksen avulla pysyt ajan tasalla uusista tuotteista, palveluista ja tarjouksista, jotka saattavat kiinnostaa sinua. Voit peruuttaa suostumuksen milloin tahansa.',
    marketingAuthorizationApproved: 'Palvelun markkinointilupa hyväksytty',
    privacyPolicy: 'Tietosuojaseloste',
    privacyPolicyInfo:
      'Lue, miten käsittelemme tietojasi tietoturvallisesti ja luotettavasti. Hyväksy ilmoitus jatkaaksesi.',
    privacyPolicyLinkText: 'OmaPro Portaalin tietosuojaseloste',
    privacyPolicyApproved: 'Palvelun tietosuojaseloste hyväksytty',
    cookies: 'Evästeet',
    cookieInfo:
      'Keräämme evästeitä kävijäseurantaan ja markkinointiin. Hyväksytkö evästekäytännöt?',
    termsOfUse: 'Käyttöehdot',
    termsOfUseInfo:
      'Sovellamme palveluun allaolevia käyttöehtoja. Tutustuttuasi ja hyväksyttyäsi ne, pääset jatkamaan.',
    termsOfUseLinkText: 'OmaPro Portaalin käyttöehdot',
    termsOfUseApproved: 'Palvelun käyttöehdot hyväksytty',
    infoUpdatedSuccessfully: 'Käyttäjätietojen muokkaus onnistui',
    deletedSuccessfully: 'Käyttäjän poistaminen onnistui',
    approvalChangedSuccessfully: 'Suostumuksia muokattu onnistuneesti',
    approvalModalTitle: 'Jatka kirjautumista hyväksymällä Tietosuojaseloste ja Käyttöehdot',
  },
  medicines: {
    title: 'Valmistevalikoima',
    productNumber: 'Tuote-numero',
    productName: 'Nimi',
    strength: 'Vahvuus',
    activeSubstancesDescription: 'Vaikuttava aine',
    manufacturerName: 'Valmistaja',
    availableForCustomers: 'Saatavuus',
    halving: 'Puolitettavissa annosjakelussa',
    halvable: 'Puolitettava',
    alwaysHalvable: 'Vain puolitettava',
    available: 'Saatavilla',
    inShortSupply: 'Loppumassa',
    outOfStock: 'Loppunut',
    toBeDiscontinued: 'Poistumassa valikoimasta',
    discontinued: 'Poistunut valikoimasta',
    drugFormatDescription: 'Lääkemuoto',
    tabletSplit: 'Puolitettavuus',
    crushable: 'Murskattavuus',
    additionalDosageInformation: 'Annostuslisätiedot',
    lactose: 'Laktoosi',
    medicineManual: 'Lääkeopas',
    medicineType: 'Valmisteen tyyppi',
    showMoreInfo: 'Näytä lisätiedot',
    closeMoreInfo: 'Sulje lisätiedot',
    searchManufacturer: 'Hae valmistajan nimellä',
    pharmaceuticalGroup: 'Lääkeaineryhmä',
    substituteProduct: 'Korvaava valmiste',
    drug: 'Huume',
    psychoClass: 'PKV lääke',
    trafficHazard: 'Liikennevaara',
    fimeaClass: 'Lääke75+ luokka + kommentti (Fimea)',
    activeSubstance: 'Vaikuttava aine',
    takingTheMedicine: 'Lääkkeen ottaminen',
    influence: 'Vaikutustapa',
    dosage: 'Annostus',
    purpose: 'Käyttötarkoitus',
    sideEffects: 'Haittavaikutukset',
    pregnancy: 'Raskaus ja imetys',
    storage: 'Säilytys',
    appearance: 'Ulkonäkö',
    unknown: 'Tietoa ei saatavissa',
    filters: {
      Available: 'Saatavilla',
      InShortSupply: 'Loppumassa (saatavuushäiriö)',
      OutOfStock: 'Loppunut (saatavuushäiriö)',
      ToBeDiscontinued: 'Poistumassa valikoimasta',
      Discontinued: 'Poistunut valikoimasta',
      halvingYes: 'Puolitettava',
      halvingNo: 'Ei puolitettava',
      halvingAlways: 'Vain puolitettava',
      drug: 'Lääke',
      supplement: 'Ravintolisä',
    },
    isHalvable: {
      '2': 'Vain puolitettava',
      '1': 'Puolitettava',
    },
    isSplittable: {
      '0': 'Ei saa puolittaa',
      '1': 'Saa puolittaa',
      '2': 'Vain nielemisen helpottamiseksi',
      '3': '$t(medicines.unknown)',
      '4': '$t(medicines.isSplittable.0)',
      '5': '$t(medicines.isSplittable.1)',
      '6': '$t(medicines.isSplittable.2)',
      '7': '$t(medicines.unknown)',
      '9': '$t(medicines.unknown)',
    },
    isLactose: {
      '0': 'Ei sisällä laktoosia',
      '1': 'Sisältää laktoosia',
    },
    isCrushable: {
      '0': 'Ei saa murskata',
      '1': 'Saa murskata',
      '9': '$t(medicines.unknown)',
    },
  },
  customer: {
    title: 'Oma asiakkuus',
    customerInfo: 'Yrityksen tiedot',
    customerUserList: 'Käyttäjät',
    businessName: 'Yrityksen nimi',
    businessId: 'Y-tunnus',
    taxCode: 'ALV-tunnus',
    invoiceAddress: 'Verkkolaskutusosoite (OVT)',
    operatorId: 'Operaattoritunnus (OVT)',
    doseDeliveryContactPerson: 'Annosjakelun yhteyshenkilö',
    kelaNumber: 'Kela-numero',
    doseDeliveryEmailAddress: 'Annosjakelusähköposti',
    doseDeliveryPhoneNumber: 'Annosjakelun puhelinnumero',
    invoicingInfo: 'Laskutustiedot',
    deliveryInfo: 'Toimitustiedot',
    pharmacyInfo: 'Apteekkitiedot',
    addUser: 'Lisää käyttäjä',
    inviteLinks: 'Kutsulinkit',
    pharmacist: 'Farmasisti',
    removeUser: 'Poista käyttäjä',
    removeUserTitle: 'Käyttäjätilin poistaminen',
    removeUserDesc:
      'Olet poistamassa käyttäjätiliä OmaPro Portaalista. Poistamisen jälkeen käyttäjä ei enää pääse OmaPro Portaaliin. Poistetaanko käyttäjätili?',
    roles: {
      'customer-pharmacist': 'Farmasisti',
      'customer-user': 'Peruskäyttäjä',
      'customer-user-management': 'Käyttäjien hallinta',
      'customer-view-orders': 'Annosjakelutilaukset',
      'customer-buyer': 'Osto-oikeus',
      'invoice-viewing': 'Laskujen katselu',
      'company-information-management': 'Yrityksen tietojen hallinta',
      'contract-information-viewing': 'Sopimustietojen katselu',
    },
    newUser: 'Uusi käyttäjä',
    sendInviteLink: 'Lähetä kutsulinkki',
    newUserModalTitle: 'Uuden käyttäjän lisäys',
    newUserModalDescription: 'Olet lähettänyt kutsulinkin seuraavaan sähköpostiosoitteeseen:',
    newInviteLinkExpiresIn: 'Kutsulinkki on voimassa 60 min.',
    ordersApiKeyTooltip: 'Portaalin kautta salasanan voi vaihtaa vain asiakkuuden pääkäyttäjä.',
    ordersApiKeyTitle: 'Tilausrajapinnan salasana',
    ordersApiKeyDisclaimer:
      'Aloita tilausrajapinnan salasanan vaihtaminen painamalla Luo uusi salasana -painiketta. Vahvistamisen jälkeen uusi salasana tulee näkyviin alla olevaan kenttään, jolloin voit kopioida sen leikepöydälle. Uusi salasana astuu voimaan välittömästi ja se tulee vaihtaa apteekkijärjestelmään heti resetoinnin jälkeen.',
    ordersApiKeyResetButton: 'Luo uusi salasana',
    ordersApiKeyCopyToClipboard: 'Kopioi leikepöydälle',
    ordersApiKeyModalDisclaimer:
      'Olet luomassa uutta tilausrajapinnan salasanaa. Uusi salasana astuu voimaan välittömästi ja se tulee vaihtaa apteekkijärjestelmään heti resetoinnin jälkeen. Haluatko jatkaa?',
    ordersApiKeyModalOkButton: 'Luo uusi salasana',
    ordersApiKeyModalTitle: 'Tilausrajapinnan salasanan vaihto',
    reports: {
      reports: 'Raportit',
      reportType: 'Raportin tyyppi',
      download: 'Lataa raportti',
      formReport: 'Muodosta raportti',
      noReportToShow: 'Ei näytettävää raporttia',
      timeInterval: 'Aikaväli',
      purchaseReport: 'Ostoraportti',
      productBreakdown: 'Tuotekohtainen erittely',
      customerGroupBreakdown: 'Asiakasryhmäkohtainen erittely',
      timeIntervalTooltip: 'Valitse enintään 31 päivän aikaväli. Raportin sisältö muodostuu valitun aikavälin toimituksista.',
      reportTypeTooltip: 'Asiakasryhmäkohtainen erittely = Tilaustiedot asiakasryhmittäin. Ostoraportti = Tuotteet jaoteltuna apteekkiverollisiin ja  -verottomiin tuotteisiin.',
      modalTitle: 'Raportti muodostuu, odota hetki.'
    },
  },
  customerService: {
    customerInfoLink: 'Customer info',
    customerSelectInput: {
      placeholder: 'Valitse asiakas',
      searchInstruction: 'Syötä vähintään 3 merkkiä',
    },
  },
  extranetCard: {
    buttonLabel: 'Lue lisää',
  },
  orderHistory: {
    title: 'Tilaushistoria',
    orderCount: 'Tilauksia',
    select: 'Valitse',
    orderDate: 'Tilauspvm',
    customerGroup: 'Asiakasryhmä',
    groupOrderCount: 'Tilausmäärä',
    orderState: 'Tilauksen tila',
    name: 'Nimi',
    dateOfBirth: 'Syntymäaika',
    subscriptionPeriod: 'Tilausjakso',
    orderNumber: 'Tilausnumero',
    comments: 'Huomiot',
    deliveryDate: 'Lähetyspvm',
    orderChanges: 'Tilausmuutokset',
    orderChange: 'Tilausmuutos',
    urgent: 'Pikatilaus',
    productNumber: 'Tuotenumero',
    showOrderChanges: 'Näytä vain muutoksia sisältävät tilaukset',
    status: {
      arrived: 'Vastaanotettu',
      'in-manufacturing': 'Tuotannossa',
      'missing-information': 'Odottaa tietoja',
      sent: 'Lähetetty',
      cancelled: 'Peruttu',
    },
    listOfChangesButton: 'Listaus muutoksista',
    dosageCards: 'Annostuskortit',
    dosageCardButtonMobileTooltip:
      'Tilauksen tilan tulee olla "Lähetetty", että tulostaminen on mahdollista.',
    dosageCardButtonTooltip:
      'Valitse tulostettavat tilaukset tai asiakasryhmät. Tilauksen tilan tulee olla "Lähetetty", että tulostaminen on mahdollista.',
    orderChangesButtonTooltip:
      'Valitse tilaukset, joiden muutoksia haluat katsella tai tulostaa. Valittuna tulee olla vähintään yksi tilaus, jossa on muutoksia. Listaus aukeaa erilliseen ikkunaan.',
    vnrSearchPlaceholder: 'Suodata tuotenumeron perusteella',
  },
  productShortages: {
    title: 'Tuotepuutokset',
    noShortages: 'Ei tuotepuutoksia',
    allGood: 'Kaikki kunnossa!',
    subscriptionPeriodInfo:
      'Listauksessa näkyy ne asiakkaat, joiden viimeisin tilausjakso on sisältänyt huomiota vaativaa valmistetta.',
    replaceableProduct: 'Vaihdettava valmiste',
  },
  inviteLinks: {
    openInvites: 'Avoimet kutsulinkit',
    inviteCreator: 'Kutsulinkin tekijä',
    InvitationLinkRecipientEmail: 'Kutsulinkin saajan sähköposti',
    expires: 'Vanhentuu',
    usable: 'Käytettävissä',
    roles: 'Käyttäjäroolit',
    cancelInviteLink: 'Peruuta kutsulinkki',
    cancelInviteLinkModal: 'Kutsulinkin peruutus',
    cancelInviteLinkDescription: 'Haluatko varmasti peruuttaa kutsulinkin osoitteeseen: ',
    cancelInviteLinkSuccess: 'Kutsulinkki poistettu onnistuneesti',
    signUpToExtranet: 'Kirjaudu OmaPro Portaaliin',
    inviteLinkExpired: 'Kutsulinkkisi ei ole voimassa.',
    inviteLinkAskNew: 'Pyydä uusi kutsulinkki jatkaaksesi kirjautumista.',
    toSignin: 'Siirry kirjautumissivulle',
    registration: {
      title: 'Tervetuloa OmaPro Portaaliin',
      subtitle: 'Rekisteröidy täyttämällä alla olevat tiedot',
      usernamePlaceholder: 'Kirjoita käyttäjätunnus',
      usernameMaxLengthError: 'Käyttäjätunnus saa olla korkeintaan 32 merkkiä pitkä',
      usernameMinLengthError: 'Käyttäjätunnuksen tulee olla vähintään 5 merkkiä pitkä',
      usernamePatternError: 'Käyttäjätunnus ei saa sisältää välilyöntejä',
      passwordAgain: 'Salasana uudelleen',
      passwordPlaceholder: 'Vähintään 15 merkkiä',
      passwordMinLengthError: 'Salasanan tulee olla vähintään 15 merkkiä pitkä',
      passwordsDoNotMatch: 'Salasanat eivät täsmää',
      passwordPatternError:
        'Salasanan tulee sisältää isoja kirjaimia, pieniä kirjaimia, numeroita ja erikoismerkkejä',
      userNameTooltip:
        'Luo turvallinen, helposti muistettava käyttäjätunnus käyttämällä pieniä kirjaimia sekä numeroita. Vältä henkilökohtaisia tietoja ja älä käytä samaa tunnusta eri palveluissa. Käyttäjätunnuksessa ei voi käyttää erikoismerkkejä tai kirjaimia å, ä tai ö.',
      passwordTooltip:
        'Salasanan tulee olla vähintään 15 merkkiä pitkä ja sisältää isoja kirjaimia, pieniä kirjaimia, numeroita ja erikoismerkkejä',
      marketingAuthorizationInfo:
        'Tämän suostumuksen avulla pysyt ajan tasalla uusista tuotteista, palveluista ja tarjouksista, jotka saattavat kiinnostaa sinua. Voit peruuttaa suostumuksen milloin tahansa.',
      privacyPolicyInfo:
        'Lue, miten käsittelemme tietojasi tietoturvallisesti ja luotettavasti. Hyväksy ilmoitus jatkaaksesi.',
      extranetPrivacyPolicy: 'OmaPro Portaalin tietosuojaseloste',
      extranettermsOfUse: 'OmaPro Portaalin käyttöehdot',
      newUserSuccess: 'Uusi käyttäjä luotu onnistuneesti',
      newUserError: 'Uuden käyttäjän luominen epäonnistui',
      newUserNameConflict: 'Käyttäjänimi on jo käytössä',
      emailTooltip:
        'Sähköpostiosoitteena käytetään osoitetta, johon kutsu on lähetetty. Sähköpostiosoitteen voi vaihtaa jälkikäteen omista tiedoista.',
      countryTooltip:
        'Kirjoita maakoodi, esim. Suomen maakoodi "FI", ISO 3166 standardin mukaisesti.',
      selectProfessionalRoleTitle: 'Valitse ammattiroolit',
      selectProfessionalRoleInfo:
        'Ammattiroolit vaikuttavat näkemääsi sisältöön ja laajentavat materiaalivalikoimaasi. Valitsemalla ammattiroolin vakuutat, että olet oikeutettu tarkastelemaan kyseiselle kohderyhmälle tarkoitettua sisältöä.',
      noSelectedProfessionalRole: 'Ei ammattiroolia',
    },
  },
  customerGroupSettings: {
    title: 'Asiakasryhmien hallinta',
    update: 'Asiakasryhmien muokkaus',
    customer: 'Asiakasryhmä',
    activity: 'Aktiivisuus',
    selectPricing: 'Valitse annosjakelupalkkio',
    activityTooltip:
      'Ryhmän tila on aktiivinen, kun siihen on tehty tilauksia viimeisen 8 viikon aikana.',
    doseDispensingFee: 'Annosjakelupalkkio',
    doseDispensingFeeNotSet: 'Annosjakelupalkkiota ei asetettu',
    doseDispensingFeeTooltip:
      'Kiinnittäkää asiakasryhmälle annosjakelupalkkio. Annosjakelupalkkio määräytyy hinnoittelusopimuksen perusteella.',
    orderTime: 'Tilausmääräaika',
    orderTimeNotSet: 'Tilausmääräaikaa ei asetettu',
    orderTimeTooltip:
      'Asettakaa asiakasryhmälle tilausmääräaika. Sovittehan tilausaikataulusta asiakaspalvelumme kanssa ennen tilausmääräajan asettamista, jos teillä on aloittamassa suuri määrä (yli 50 asiakasta) kerralla tai haluatte ottaa käyttöön uuden tilauspäivän. Huomioittehan, että tilausmääräaikaa tulisi jatkossa muuttaa vain painavista syistä.',
    doseBagLayout: 'Annospussin ulkoasu',
    doseBagLayoutTooltip:
      'Valitkaa "Iso printti" jos haluatte kaikille asiakasryhmän asiakkaille isomman fontin annospussien päivämäärä- ja kellonaikatiedoille.',
    disclosure: 'Tietojen luovutus',
    disclosureTooltip:
      'Valitsemalla alla olevasta valikosta kolmannen osapuolen, annat annosjakeluyksikölle oikeuden luovuttaa tarvittavat loppukäyttäjän annosjakelutiedot kyseiselle osapuolelle. Huomioithan, että Smila-lääkeannostelija tarvitsee tiettyjä annospussitietoja toimiakseen.',
    stickerlessGroup: 'Tarraton ryhmä',
    stickerlessGroupTooltip:
      'Valitkaa "Tarraton ryhmä" jos haluatte kaikki asiakasryhmän rullat ilman sulkutarroja.',
    nextOrderDeadline: 'Seuraava tilausmääräaika',
    selectedOrderDeadline: 'Valittu tilausmääräaika',
    selectableOrderDeadline: 'Valittavissa oleva tilausmääräaika',
    noSelectableTimes: 'Ei valittavia aikoja',
    updateModal: {
      title:
        'Huom! Olet muuttamassa asiakasryhmän asetuksia. Uudet asetukset astuvat voimaan seuraavasta tilauksesta.',
      content:
        'Huomioittehan, että tuotannon asiakasmääriä seurataan tarkasti, ja tilausmääräaikaa tulisi muuttaa vain painavista syistä. Sovittehan tilausaikataulun muutoksista asiakaspalvelumme kanssa hyvissä ajoin ennen muutoshetkeä, jos muutos koskee suurta määrää (yli 50 asiakasta) kerralla.',
      confirmation: 'Tallennetaanko muutokset asiakasryhmälle?',
    },
    normalLayout: 'Normaali',
    bigFontLayout: 'Iso Printti',
    notSet: 'Ei asetettu',
    scheduleNotSet: 'Aikataulu asettamatta',
    groupUpdatedSuccessfully: 'Ryhmää muokattu onnistuneesti',
    contract: 'Sopimus',
    dataRelease: 'Ei luovuteta',
    smilaGroupSticker:
      'Smila-ryhmän tulee olla tarraton. Palaa takaisin ja valitse tarraton ryhmä.',
    nextOrderTime: {
      notSet: 'Ei asetettu',
      nextOrderDeadline: 'Seuraava tilausmääräaika',
      selectedOrderDeadline: 'Valittu tilausmääräaika',
      availableOrderDeadline: 'Valittavissa oleva tilausmääräaika',
    },
    nextOrderDeadlineTooltip:
      'Tämä on ennustettu normaalin aikataulun mukainen tilauspäivä, eikä siinä huomioida mahdollisia erikseen sovittuja poikkeusaikatauluja tai arkipyhiä. Tarkemmat tilausaikataulut voi tarkistaa "Tilausaikataulut/ Poikkeukset" -sivulta.',
  },
  unauthorized: {
    welcome: 'Tervetuloa OmaPro Portaaliin',
    redirect: 'Sinut uudelleenohjataan automaattisesti 10 sekunnin kuluttua',
    noAuth: 'Ei pääsyä',
    noLink: 'Käyttäjätunnukseen ei ole liitetty yhtään asiakasta',
  },
  physicalProducts: {
    orderMaterialTabTitle: 'Materiaalin tilaus',
    orderedMaterialTabTitle: 'Tilatut materiaalit',
    totalPrice: 'Hinta yht',
    total: 'Yhteensä',
    vat: 'ALV',
    vatLowercase: 'alv',
    priceByPcs: 'À-hinta',
    orderDate: 'Tilauspäivä',
    shoppingCartButton: 'Tilaa',
    freeMaterial: 'Ilmainen',
    priceTooltip:
      'Materiaalit laskutetaan seuraavan annosjakelutilauksen yhteydessä. Maksullisten materiaalien tilaaminen vaatii osto-oikeus -roolin.',
    quantityTooltip:
      'Tilausmäärä on max. 30 kpl/tilattava materiaali. Jos on tarve tilata kerralla isompi määrä materiaalia, olettehan yhteydessä edustajaanne ennen tilauksen tekoa.',
    shoppingCart: {
      title: 'Tilauksen yhteenveto',
      sendOrder: 'Lähetä tilaus',
      footerMessage: 'Tilaamasi materiaalit saapuvat seuraavan annosjakelutoimituksen yhteydessä.',
      orderSuccess: 'Tilauksen lähetys onnistui',
    },
  },
  correctionRequests: {
    titleTooltip:
      'Korjauspyyntö lähetetään, mikäli tilauksessa oleva tuote on äkillisesti loppunut tuotannosta. Tällöin asiakkaalle tulee tehdä uusi tilaus mahdollisimman pian, ilman pikatilausmerkintää. Kun uusi tilaus on tehty, korjauspyyntö tulee merkitä käsitellyksi Aktiiviset korjauspyynnöt -välilehdellä.',
    activeRequests: 'Aktiiviset korjauspyynnöt',
    checkedRequests: 'Kuitatut korjauspyynnöt',
    requestArrivedAt: 'Korjauspyyntö saapunut',
    missingProduct: 'Puuttuva tuote',
    substituteProduct: 'Korvaava tuote',
    requestCheck: 'Korjauspyynnön kuittaus',
    requestCheckByPharmac: 'Korjauspyyntö umpeutunut',
    requestCheckTooltip:
      'Kuittaamalla korjauspyynnön vahvistat, että korjauspyyntö on huomioitu ja uusi tilaus on tehty.',
    requesCheckedBy: 'Korjauspyyntö kuitattu',
    requesCheckedSuccess: 'Korjauspyyntö kuitattu onnistuneesti',
    noCorrectionRequests: 'Ei korjauspyyntöjä',
    customerName: 'Asiakkaan nimi',
    searchByName: 'Hae nimellä',
  },
  contact: {
    openTicketsTabTitle: 'Avoimet keskustelut',
    closedTicketsTabTitle: 'Suljetut keskustelut',
    startNewTicketButton: 'Aloita uusi keskustelu',
    newTicketModalTitle: 'Uusi keskustelu',
    newTicketModalInfo:
      'Voit olla tietoturvallisesti yhteydessä kaikissa asioissa. Vastaamme yhteydenottoihin asiakaspalvelun aukioloaikoina.',
    subject: 'Aihe',
    subjectAreaLabel: 'Aihealue',
    subjectAreaInfo: 'Valitse aihealue, joka kuvaa parhaiten asiaasi.',
    confidentialTicketButton: 'Sisältää arkaluontoista tietoa',
    privateTicketButton: 'Yksityinen keskustelu',
    privateTicketInfo: 'Yksityinen keskustelu näkyy vain sinulle ja asiakaspalvelijalle.',
    confidentialTicketInfo:
      'Merkitse viesti arkaluontoiseksi, jos se sisältää esimerkiksi tunnistettavia henkilötietoja. Keskustelun kuvaus, liitteet ja kommentit poistetaan tietosuojaselosteessa määritetyn säilytysajan mukaisesti.',
    confidentialTicketInfoLinkText: 'Tietosuojaseloste',
    state: 'Tila',
    createdAt: 'Luotu',
    updatedAt: 'Päivitetty',
    writer: 'Kirjoittaja',
    description: 'Kuvaus',
    attachments: 'Liitteet',
    addAttachment: 'Liitä tiedosto',
    comments: 'Kommentit',
    addComment: 'Lisää kommentti',
    sendButton: 'Lähetä',
    reopenTicket: 'Avaa keskustelu uudelleen',
    cancelTicket: 'Peruuta keskustelu',
    cancelTicketModal:
      'Haluatko  varmasti peruuttaa keskustelun? Valitse "Peruuta keskustelu", jos  keskustelu on tarpeeton. Peruutettua keskustelua ei ole mahdollista  avata uudelleen.',
    closeTicket: 'Merkitse keskustelu valmiiksi',
    closeTicketModal:
      'Haluatko varmasti merkitä keskustelun valmiiksi? Valitse "Merkitse keskustelu valmiiksi", kun olet saanut vastauksen yhteydenottoosi ja asiasi on ratkaistu. Valmiin keskustelun saa tarvittaessa avattua uudelleen 5 päivän sisällä.',
    new: 'Uusi',
    inProgress: 'Käsittelyssä',
    repliedByPharmac: 'Vastattu Pharmacilta',
    closed: 'Suljettu',
    cancelled: 'Peruutettu',
    resolved: 'Valmis',
    commentAddedToast: 'Kommentti lisätty',
    noComments: 'Ei vielä kommentteja',
    wrongFileTypeError: 'Väärä tiedostomuoto, sallitut tiedostomuodot .pdf, .jpg, .png, .webp',
    acceptableFileTypes: 'Sallitut tiedostomuodot .pdf, .jpg, .png, .webp',
  },
  orderSchedules: {
    titleTooltip:
      'Mikäli toivotte muutosta suunniteltuihin poikkeusaikatauluihin, olkaa yhteydessä Pharmaciin käyttämällä yhteydenottolomaketta',
    onlyExceptionsSwitch: 'Näytä vain poikkeukset',
    orderPrediction: 'Tilausennuste',
    exceptions: 'Poikkeukset',
    periodLength: 'Jakson pituus',
    atThePharmacy: 'Perillä apteekissa',
    double: 'Tuplaus',
    transfer: 'Siirto',
    noExceptions: 'Ei poikkeuksia',
    doubledOffDate: 'Tuplattu pois päivältä',
    transferedOffDate: 'Siirretty pois päivältä',
    includesExceptions: 'Sisältää poikkeuksia',
    expectionDate: 'Poikkeava tilausmääräaika',
    movedFromDate: 'Siiretty päivältä',
    movedFromDates: 'Siirretty päiviltä',
    doubledFromDate: 'Tuplattu päivältä',
    doubledFromDates: 'Tuplattu päiviltä',
    removedFromDate: 'Poistettu päivältä',
    noExceptionSchedules: 'Ei poikkeusaikatauluja',
    noOrderSchedulesDesc:
      'Tee ensimmäinen tilauksesi ja aseta aikataulut, jotta tilausaikatauluennusteet tulevat näkyviin.',
    days: 'vrk',
    removed: 'Poisto',
  },
  billedDeliveries: {
    deliveryNumber: 'Toimitusnumero',
    shippingDate: 'Lähetyspäivä',
    deliveryBreakdown: 'Tuote- ja tilauskohtainen erittely',
    orderBreakdown: 'Tilauskohtainen erittely ja ostoraportti',
    searchByDeliveryNumber: 'Hae toimitusnumerolla',
    deliveryBreakdownTooltip:
      'Valitse tulostettava tuote- ja tilauskohtainen erittely. Tiedoston suuren koon vuoksi voit ladata vain yhden erittelyn kerrallaan. Jos valitset useamman rivin, latauspainike ei ole käytettävissä.',
    orderBreakdownTooltip:
      'Valitse tulostettavat tilauskohtaiset erittelyt ja ostoraportit. Tiedostojen suuren koon vuoksi voit ladata enintään 10 erittelyä kerrallaan. Jos valitset yli 10 riviä, latauspainike ei ole käytettävissä.',
  },
  shop: {
    allProducts: 'Kaikki tuotteet',
    wholeCatalog: 'Koko valikoima',
    ownProducts: 'Omat tuotteet',
    noOwnProducts:
      'Hei! Tarjolla olevat ohjeet, oppaat, webinaarit, sopimuspohjat, sekä koulutukset saat hankittua käyttöösi OmaPro Portaalin kaupasta. Hankkituasi materiaalia, löydät ne kootusti aina täältä.',
    noBuyerRoleTooltip: 'Sinulla ei ole osto-oikeusroolia, ota yhteyttä pääkäyttäjään.',
    purchaseRightDeniedTooltip: 'Osto-oikeus evätty',
    noRequiredProfRolesTooltip: 'Sinulla ei ole tuotteen aktivoimiseen tarvittavaa ammattiroolia',
    noRequiredProfRolesForDownloadTooltip: 'Sinulla ei ole tarvittavaa ammattiroolia',
    published: 'Julkaistu',
    availableIndefinitely: 'Rajaton katseluaika',
    addedToOwnProducts: 'Lisätty omiin tuotteisiin',
    removedFromOwnProducts: 'Tuote poistettu omista tuotteista',
    cart: {
      emptyCartTitle: 'Ostoskorisi on tyhjä',
      emptyCartDesc:
        'Tutustu tuote- ja palveluvalikoimaamme. Voit hankkia tuotteita lisäämällä niitä ostoskoriin.',
      emptyCartButton: 'Siirry kauppaan',
      acceptTerms: 'Hyväksyn tilaus- ja toimitusehdot. Lue ehdot ',
      here: 'tästä.',
      missingRoles:
        'Voit ostaa tämän tuotteen, mutta et voi aktivoida sitä, koska sinulta puuttuu vaadittava ammattirooli. Poista tuote ostoskorista tai jatka tilaamaan, jos olet ostamassa tuotteen lahjaksi.',
      orderSendSuccess: 'Tilaus lähetetty onnistuneesti',
      totalPrice: 'Veroton yht.',
    },
    filters: {
      order: 'Järjestys',
      alphabetically: 'Aakkosittain',
      newest: 'Uusin ensin',
      oldest: 'Vanhin ensin',
      cheapest: 'Edullisin ensin',
      mostExpensive: 'Kallein ensin',
      priceType: 'Hintatyyppi',
      fee: 'Maksullinen',
      free: 'Maksuton',
      tags: 'Tagit',
    },
    removeProductModal: {
      title: 'Poista tuote',
      description:
        'Olet poistamassa tuotetta omista tuotteistasi. Voit lisätä tuotteen kaikki tuotteet-välilehdeltä takaisin omiin tuotteisiisi milloin vain.',
    },
    product: {
      viewable: 'Katsottavissa',
      till: 'saakka',
      unlimitedAccess: 'Rajaton katseluaika',
      preview: 'Esikatseluvideo',
      notActivated: 'Tuotetta ei ole aktivoitu',
      requiredRoles: 'Tarvittavat ammattiroolit',
      noRequiredRoles: 'Ei rajoitteita',
      activated: 'Tuote on aktivoitu',
      videoNotAvailable: 'Video ei saatavilla',
      pictureNotAvailable: 'Kuvaa ei saatavilla',
    },
    buttons: {
      buyAgain: 'Osta uudestaan',
      learnMore: 'Tutustu',
      addToCart: 'Lisää ostoskoriin',
      removeFromCart: 'Poista ostoskorista',
      addToOwnProducts: 'Lisää omiin tuotteisiin',
      goTo: 'Siirry',
      downloadDocument: 'Lataa dokumentti',
      activate: 'Aktivoi',
      activeteProduct: 'Aktivoi tuote',
      downloadTemplate: 'Lataa sopimuspohja',
    },
    activateCodeModal: {
      title: 'Aktivoi tuotekoodi',
      addCode: 'Syötä koodi',
      customer: 'Olet aktivoimassa tuotteen asiakkaana',
      usageTime: 'Käyttöaika',
      roleError:
        'Sinulla ei ole tuotteen aktivoimiseen tarvittavaa ammattiroolia. Löydät vaadittavat ammattiroolit tuotekuvauksesta.',
      codeError: 'Syöttämäsi koodi on väärä',
      expiredError: 'Tuote ei ole enää aktivoitavissa',
      usedError: 'Aktivointikoodi on jo käytetty',
      activatedError: 'Tuote on jo aktivoitu',
      activateProductSuccess: 'Tuote aktivoitu onnistuneesti',
    },
    orders: {
      shopOrders: 'Verkkokauppatilaukset',
      orderNumber: 'Tilausnumero',
      orderDate: 'Tilauspäivä',
      orderStatus: 'Tilauksen tila',
      totalPrice: 'Hinta yht. veroton',
      purchaserName: 'Ostaja',
      statuses: {
        arrived: 'Vastaanotettu',
        cancelled: 'Peruttu',
        beingProcessed: 'Käsittelyssä',
        delivered: 'Toimitettu',
        completed: 'Valmis',
        partiallyDelivered: 'Osittain toimitettu',
        sent: 'Lähetetty',
      },
      orderRow: 'Tilausrivi',
      productName: 'Tuotteen nimi',
      quantity: 'Määrä',
      unitPrice: 'À-hinta',
      status: 'Tila',
      deliveryNumber: 'Toimitusnumero',
      codes: {
        externalUser: 'Ulkoinen käyttäjä',
        used: 'Käytetty',
        unused: 'Käyttämätön',
        activationCodes: 'Aktivointikoodit',
        copy: 'Kopioi',
      },
    },
  },
  shopProducts: {
    document: 'Dokumentti',
    video: 'Video',
    videos: 'Tallenteet',
    documents: 'Dokumentit',
    serviceProduct: 'Palvelu',
    serviceProducts: 'Palvelut',
    physicalProduct: 'Oheistuote',
    materialType: 'Materiaalin tyyppi',
    releaseDateRange: 'Julkaisuaikaväli',
    description: 'Kuvaus',
    chapters: 'Osat',
    goTo: 'Siirry',
    downloadDocument: 'Lataa dokumentti',
    relatedProducts: 'Oheistuotteet',
  },
  footer: {
    contact: 'Ota yhteyttä',
    links: 'Linkit',
    privacyPolicy: 'Tietosuojaseloste',
    termsOfUse: 'Käyttöehdot',
    shopTermsAndConditionsOfContractAndDelivery: 'Verkkokaupan sopimus- ja toimitusehdot',
    oivaReport: 'Oiva-raportti',
  },
}

const common = {
  greeting: 'Hei',
  yes: 'Kyllä',
  no: 'Ei',
  welcome: 'Tervetuloa',
  home: 'Etusivu',
  users: 'Käyttäjät',
  orders: 'Tilaukset',
  pharmacies: 'Apteekit',
  taksa: 'Taksa',
  catalog: 'Tuotekatalogi',
  admin: 'Ylläpito',
  settings: 'Asetukset',
  accept: 'Hyväksy',
  logout: 'Kirjaudu ulos',
  login: 'Kirjaudu sisään',
  signUp: 'Rekisteröidy',
  deleted: 'Poistettu',
  arrived: 'Saapunut',
  return: 'Paluu',
  search: 'Hae...',
  noSearchResultsTitle: 'Hakuehdoillasi ei löytynyt yhtään tulosta!',
  noSearchResultsDescription: 'Tarkista hakuehtosi tai laajenna niitä.',
  notFoundPageTitle: 'Etsimääsi sivua ei löydy!',
  notFoundPageMessage: 'Siirry etusivun tai valikon kautta haluamallesi sivulle.',
  filters: 'Suodattimet',
  category: 'Kategoria',
  categories: 'Kategoriat',
  favourite: 'Suosikki',
  firstName: 'Etunimi',
  lastName: 'Sukunimi',
  phoneNumber: 'Puhelin',
  streetName: 'Katuosoite',
  emailAddress: 'Sähköpostiosoite',
  postCode: 'Postinumero',
  townName: 'Postitoimipaikka',
  userName: 'Käyttäjätunnus',
  countryCode: 'Maakoodi',
  country: 'Maa',
  certificateCardNumber: 'Varmennekortin numero',
  clipboardSuccess: 'Kopioitu leikepöydälle',
  clipboardError: 'Kopiointi epäonnistui',
  changePassword: 'Vaihda salasana',
  password: 'Salasana',
  cancel: 'Peruuta',
  save: 'Tallenna',
  basicInfo: 'Perustiedot',
  contactPersonName: 'Yhteyshenkilö',
  edit: 'Muokkaa',
  moreInfo: 'Lisätiedot',
  week: 'Viikko',
  selectDateRange: 'Aseta päivämääräväli',
  selectDate: 'Aseta päivämäärä',
  endDateText: 'Päättyen pvm',
  startDateText: 'Alkaen pvm',
  clock: 'klo',
  pcs: 'kpl',
  continue: 'Jatka',
  alternateWeek: 'Vuoroviikko',
  requiredFieldError: 'Pakollinen tieto',
  emailPatternError: 'Virheellinen sähköpostiosoite',
  active: 'Aktiivinen',
  passive: 'Passiivinen',
  monday: 'Maanantai',
  tuesday: 'Tiistai',
  wednesday: 'Keskiviikko',
  thursday: 'Torstai',
  friday: 'Perjantai',
  mondayShort: 'ma',
  tuesdayShort: 'ti',
  wednesdayShort: 'ke',
  thursdayShort: 'to',
  fridayShort: 'pe',
  saturdayShort: 'la',
  sundayShort: 'su',
  class: 'Luokka',
  comment: 'Kommentti',
  chooseCustomer: 'Valitse edustamasi asiakas alla olevasta listasta jatkaaksesi.',
  timeoutTitle: 'Istuntosi on vanhentumassa',
  timeoutContent1: 'Sinut kirjataan automaattisesti ulos',
  timeoutContent2: 'kuluttua. Haluatko jatkaa OmaPro Portaalin käyttöä?',
  timeoutMinutes: 'minuutin',
  timeoutSeconds: 'sekunnin',
  all: 'Kaikki',
  nb: 'Huom!',
  name: 'Nimi',
  quantity: 'Määrä',
  price: 'Hinta',
  professionalRoles: 'Ammattiroolit',
  language: 'Kieli',
  fi: 'Suomi',
  sv: 'Ruotsi',
  en: 'Englanti',
  roles: 'Roolit',
  free: 'Ilmainen',
  remove: 'Poista',
  dayShort: 'pv.',
  monthShort: 'kk.',
  yearShort: 'v.',
  buyingBan: 'Ostokielto',
  einvoice: 'Sähköinen lasku',
  emailInvoice: 'Sähköpostilasku',
  printInvoice: 'Paperilasku',
}

export type CommonTranslation = typeof common

export type ExtranetTranslation = typeof translation

export const languageFi: ExtranetTranslation = translation
export const commonFi: CommonTranslation = common
